import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { venueAdminGetVenueApi } from '../../../api/venue/venueAdminGetVenue';
import { venueGetVenueApi } from '../../../api/venue/venueGetVenueApi';
import { Venue } from '../../../graphql/API';
import { clearCurrentVenueID, getCurrentVenueID } from '../../../utils/current-venue';

export const fetchVenue = createAsyncThunk('venues/fetchVenue', async () => {
  const master = await venueAdminGetVenueApi();
  const currentVenueID = getCurrentVenueID();

  if (currentVenueID && currentVenueID !== master.id) {
    try {
      const current = await venueGetVenueApi(currentVenueID);

      // Only honor the stored selection if the venue is actually linked to this master account
      if (String(current.masterVenueID) === String(master.id)) {
        return { current, master };
      }
    } catch (err) {
      console.error(err);
    }
    clearCurrentVenueID();
  }

  return { current: master, master };
});

export interface VenueState {
  value?: Venue;
  masterVenue?: Venue;
  isLoading?: boolean;
}

const initialState: VenueState = {
  value: undefined,
  masterVenue: undefined,
  isLoading: true,
};

export const venueSlice = createSlice({
  name: 'venue',
  initialState,
  reducers: {
    reset: () => initialState,
    updateCredit: (state, action: PayloadAction<number>) => {
      if (state.value?.availableDownloads) {
        state.value.availableDownloads += action.payload;
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchVenue.fulfilled, (state, action) => {
      state.isLoading = false;
      state.value = action.payload.current;
      state.masterVenue = action.payload.master;
    });
  },
});

export const { reset, updateCredit } = venueSlice.actions;

export default venueSlice.reducer;
